import { HttpErrorResponse } from '@angular/common/http'


export interface ILoadingState {
  [name: string]: ILoading
}


export interface ILoading {
  type: LoadingStateType
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
  isActivated: boolean
  counter: number
  lastError?: HttpErrorResponse
}


export enum LoadingStateType {
  default = 'default',
  loading = 'loading',
  error = 'error',
  success = 'success'
}


export function factoryLoading(type: LoadingStateType, lastState?: ILoading, lastError?: HttpErrorResponse): ILoading {
  let counter = 0

  if (lastState) {
    counter = lastState.counter
    if (lastState.isSuccess) counter = lastState.counter + 1
  }

  const state: ILoading = {
    type, counter,
    isLoading: LoadingStateType.loading === type,
    isError: LoadingStateType.error === type,
    isSuccess: LoadingStateType.success === type,
    isActivated: counter > 0
  }
  if (lastError) state.lastError = lastError
  return state
}
